import Vue from 'vue'
import Router from 'vue-router'


// 路由页面导入
import login from '../components/login.vue' //登录页面
import helloPage from '../components/helloPage.vue' //欢迎页
import main from '../components/main.vue' //主页面
import notFound from '../components/404.vue' //404页面





// 公共模块
var menu = res => require(['@/components/comps/menu.vue'], res) //公共侧边栏和顶部菜单
// 运营管理
var dataScreen = res => require(['@/components/managcent/dataScreen.vue'], res) //数据大屏
var bikeSearch = res => require(['@/components/managcent/bikeSearch.vue'], res) //车辆查询
var heatMap = res => require(['@/components/managcent/heatMap.vue'], res) //P点热力统计
var NewHeatMap = res => require(['@/components/managcent/NewHeatMap.vue'], res) //P点热力统计
var linkTrack = res => require(['@/components/managcent/linkTrack.vue'], res) //链路追踪
var dataScreenNew = res => require(['@/components/managcent/dataScreenNew.vue'], res) //新数据大屏
var operationalPosition = res => require(['@/components/managcent/operationalPosition.vue'], res) //运维位置
var searchTrackDetail = res => require(['@/components/managcent/searchTrackDetail.vue'], res) //运维轨迹
var scaleHeatMap = res => require(['@/components/managcent/scaleHeatMap.vue'], res) //分级P点统计



// 总资产管理
var totalControl = res => require(['@/components/totalAssets/totalControl.vue'], res) //总中控管理
var controlSwitchRecord = res => require(['@/components/totalAssets/controlSwitchRecord.vue'], res) //中控协议切换记录
var switchRecordDetail = res => require(['@/components/totalAssets/switchRecordDetail.vue'], res) //中控协议切换记录发送日志详情


// 资产管理
var carsMana = res => require(['@/components/mmassets/carsManage.vue'], res) //车辆管理
var carDetails = res => require(['@/components/mmassets/cardetails.vue'], res) //车辆管理
var controlMana = res => require(['@/components/mmassets/control.vue'], res) //中控管理
var controlRecord = res => require(['@/components/mmassets/controlRecord.vue'], res) //中控记录
var controlManaEdition = res => require(['@/components/mmassets/controlManaEdition.vue'], res) //中控版本管理
var iIssueList = res => require(['@/components/mmassets/iIssueList.vue'], res) //中控管理
var iIssueDetail = res => require(['@/components/mmassets/iIssueDetail.vue'], res) //中控管理
var controlLog = res => require(['@/components/mmassets/controlLog.vue'], res) //中控详情
var voltageChange = res => require(['@/components/mmassets/voltageChange.vue'], res) // 电压变化
var VehicleOperationLog = res => require(['@/components/mmassets/VehicleOperationLog.vue'], res) // 车辆操作日志
var controlDetails = res => require(['@/components/mmassets/controlDetails.vue'], res) //中控详情
var batchlist = res => require(['@/components/mmassets/batchlist.vue'], res) //批次列表
var batchDetail = res => require(['@/components/mmassets/batchDetail.vue'], res) //批次列表详情
var accessories = res => require(['@/components/mmassets/accessories.vue'], res) //配件管理
var storagelist = res => require(['@/components/mmassets/storagelist.vue'], res) //入库记录
var entryRecordDetails = res => require(['@/components/mmassets/entryRecordDetails.vue'], res) //入库记录
var accessoriesApplyRecord = res => require(['@/components/mmassets/accessoriesApplyRecord.vue'], res) //配件申请记录
var accessoriesApplyDetails = res => require(['@/components/mmassets/accessoriesApplyDetails.vue'], res) //配件申请记录
var siteInventory = res => require(['@/components/mmassets/siteInventory.vue'], res) //站点库存
var accessoryUseDetail = res => require(['@/components/mmassets/accessoryUseDetail.vue'], res) //配件使用明细记录
var accessoryConsumeDetail = res => require(['@/components/mmassets/accessoryConsumeDetail.vue'], res) //配件消耗明细记录
var transferBatch = res => require(['@/components/mmassets/transferBatch.vue'], res) //调拨批次列表
var allocationDetails = res => require(['@/components/mmassets/allocationDetails.vue'], res) //调拨批次详情
var pzIntoDetail = res => require(['@/components/mmassets/pzIntoDetail.vue'], res) // 平账入库记录详情
var pzOutDetail = res => require(['@/components/mmassets/pzOutDetail.vue'], res) // 平账出库记录详情
var receivingRecordList = res => require(['@/components/mmassets/receivingRecordList.vue'], res) // 收货记录列表
var batchCarSearchTask = res => require(['@/components/mmassets/batchCarSearchTask.vue'], res) // 批量寻车任务
var searchCarDetail = res => require(['@/components/mmassets/searchCarDetail.vue'], res) // 批量寻车任务详情
var batchCarList = res => require(['@/components/mmassets/batchCarList.vue'], res) // 批次车辆列表
var bateryAccessories = res => require(['@/components/mmassets/bateryAccessories.vue'], res) // 电池配件库
var batteryClaimRecord = res => require(['@/components/mmassets/batteryClaimRecord.vue'], res) // 电池申领记录
var bateryApplyDetail = res => require(['@/components/mmassets/bateryApplyDetail.vue'], res) // 电池申领记录详情
var batteryReceivingRecord = res => require(['@/components/mmassets/batteryReceivingRecord.vue'], res) // 电池申领收货记录
var batteryInventory = res => require(['@/components/mmassets/batteryInventory.vue'], res) // 站点电池库存
var batteryScrapList = res => require(['@/components/mmassets/batteryScrapList.vue'], res) // 电池报废列表
var allocationCarDetail = res => require(['@/components/mmassets/allocationCarDetail.vue'], res) // 按车辆查看调拨列表


//人员管理
var userList = res => require(['@/components/personlmana/userslist.vue'], res) //用户管理
var superUser = res => require(['@/components/personlmana/superUser.vue'], res) //超级卡密列表
var superUserDetail = res => require(['@/components/personlmana/superUserDetail.vue'], res) //超级卡密详情
var userdetail = res => require(['@/components/personlmana/userdetail.vue'], res) //用户详情
var proxylist = res => require(['@/components/personlmana/proxylist.vue'], res) //代理管理
var realnameQuery = res => require(['@/components/personlmana/realnameQuery.vue'], res) // 用户实名信息查询

// 订单管理
var rideorder = res => require(['@/components/ordermanag/rideorder.vue'], res) //骑行订单
var orderdetail = res => require(['@/components/ordermanag/orderdetails.vue'], res) //订单详情
var rechargeorder = res => require(['@/components/ordermanag/rechargeorder.vue'], res) //充值订单
var ridecard = res => require(['@/components/ordermanag/ridecard.vue'], res) //永久押金订单
var refundlist = res => require(['@/components/ordermanag/refundlist.vue'], res) //余额退款订单
var CyclingPackagePurchaseRecord = res => require(['@/components/ordermanag/CyclingPackagePurchaseRecord.vue'], res) // 骑行卡购买记录
var orderRefundGoDetails = res => require(['@/components/ordermanag/orderRefundGoDetails.vue'], res) // 订单退款记录详情

//统计报表
var daylist = res => require(['@/components/reportform/daylist.vue'], res) //日运营报表
var monthlist = res => require(['@/components/reportform/monthlist.vue'], res) //月运营报表
var totallist = res => require(['@/components/reportform/totallist.vue'], res) //总运营报表
var ridelist = res => require(['@/components/reportform/ridelist.vue'], res) //骑行数据分析
var userdatalist = res => require(['@/components/reportform/userdatalist.vue'], res) //用户数据分析
var paylist = res => require(['@/components/reportform/paylist.vue'], res) //充值数据分析
var bikelist = res => require(['@/components/reportform/bikelist.vue'], res) //车辆数据分析
var ridesettlementlist = res => require(['@/components/reportform/ridesettlementlist.vue'], res) // 骑行费用结算分析
var orderErrorAnalyze = res => require(['@/components/reportform/orderErrorAnalyze.vue'], res) // 订单创建失败分析
var customerCensus = res => require(['@/components/reportform/customerCensus.vue'], res) // 客服工单统计
var siteCensus = res => require(['@/components/reportform/siteCensus.vue'], res) // 站点工单统计
var noPassDetail = res => require(['@/components/reportform/noPassDetail.vue'], res) // 工单审核不通过明细
var controlDataAnalyze = res => require(['@/components/reportform/controlDataAnalyze.vue'], res) // 中控数据分析
var workOrderFaultAnalysis = res => require(['@/components/reportform/workOrderFaultAnalysis.vue'], res) // 工单故障分析报表
var ChargingReport = res => require(['@/components/reportform/ChargingReport.vue'], res) // 换电工作报表
var bikeAbnormal = res => require(['@/components/reportform/bikeAbnormal.vue'], res) // 换电工作报表
var noBoundControlBikeList = res => require(['@/components/reportform/noBoundControlBikeList.vue'], res) // 未绑定中控车辆报表
var partsMonthlyApplicationReport = res => require(['@/components/reportform/partsMonthlyApplicationReport.vue'], res) // 配件月度申请报表
var maintainWorkList = res => require(['@/components/reportform/maintainWorkList.vue'], res) // 维修工单统计
var powerChangeSummary = res => require(['@/components/reportform/powerChangeSummary.vue'], res) // 换电工作汇总
var accessoriesUseReport = res => require(['@/components/reportform/accessoriesUseReport.vue'], res) // 配件消耗明细报表
var vehicleAssetsReport = res => require(['@/components/reportform/vehicleAssetsReport.vue'], res) // 车辆资产报表
var cyclingCardSalesReport = res => require(['@/components/reportform/cyclingCardSalesReport.vue'], res) // 骑行卡销售报表

//营销管理
var ridecoupon = res => require(['@/components/market/ridecoupon.vue'], res) //骑行券
var operatePublic = res => require(['@/components/market/operatePublic.vue'], res) //运营公告
var taskConfig = res => require(['@/components/market/taskConfig.vue'], res) // 任务配置
var activeConfig = res => require(['@/components/market/activeConfig.vue'], res) // 活动配置
var batchTasksLog = res => require(['@/components/market/batchTasksLog.vue'], res) // 批量下发骑行日志
var activity = res => require(['@/components/market/activity.vue'], res) //骑行券相关配置
var carCardDiscountSetting = res => require(['@/components/market/carCardDiscountSetting.vue'], res) // 骑行卡折扣设置
var userLabelConfiguration = res => require(['@/components/market/userLabelConfiguration.vue'], res) // 用户标签配置
var ridePackageSetiing = res => require(['@/components/market/ridePackageSetiing.vue'], res) //骑行卡相关配置
var camiloSetting = res => require(['@/components/market/camiloSetting.vue'], res) //骑行卡密管理
var camiloDetail = res => require(['@/components/market/camiloDetail.vue'], res) //骑行卡密详情
// 客服工单
var servicepool = res => require(['@/components/orderpool/servicepool.vue'], res) //工单池
var rodeOrderPool = res => require(['@/components/orderpool/rodeOrderPool.vue'], res) //骑行退款工单池
var pending = res => require(['@/components/orderpool/pending.vue'], res) // 我待处理的
var processed = res => require(['@/components/orderpool/processed.vue'], res) // 我已处理的
var carsAudit = res => require(['@/components/orderpool/carsAudit.vue'], res) // 车辆信息审核
var userReturnCar = res => require(['@/components/orderpool/userReturnCar.vue'], res) // 车辆信息审核
var appealWorkPool = res => require(['@/components/orderpool/appealWorkPool.vue'], res) // 申诉工单池


// 运维管理
var dispatch = res => require(['@/components/operat/dispatch.vue'], res) //调度记录
var dispatchDetail = res => require(['@/components/operat/dispatchDetail.vue'], res) //调度详情
var batchDispatchDetail = res => require(['@/components/operat/batchDispatchDetail.vue'], res) //批量调度详情
var offlinelist = res => require(['@/components/operat/offlinelist.vue'], res) //离线记录
var leaveDetail = res => require(['@/components/operat/leaveDetail.vue'], res) //离线详情
var replacebatte = res => require(['@/components/operat/replacebatte.vue'], res) //换电池记录
var batteDetail = res => require(['@/components/operat/batteDetail.vue'], res) //换电详情
var repairlist = res => require(['@/components/operat/repairlist.vue'], res) //维修记录
var repairDetail = res => require(['@/components/operat/repairDetail.vue'], res) //维修详情
var violatDetail = res => require(['@/components/operat/violatDetail.vue'], res) //违规详情
var controlLeaveList = res => require(['@/components/operat/controlLeaveList.vue'], res) //中控下线记录
var orderRefundDetails = res => require(['@/components/operat/orderRefundDetails.vue'], res) //骑行订单退款详情
var carsAuditDetail = res => require(['@/components/operat/carsAuditDetail.vue'], res) //车辆信息审核详情
var carInformationEntry = res => require(['@/components/operat/carInformationEntry.vue'], res) //车辆信息录入记录
var carInformationDetail = res => require(['@/components/operat/carInformationDetail.vue'], res) //车辆信息录入记录详情
var userReturnCarDetail = res => require(['@/components/operat/userReturnCarDetail.vue'], res) //用户申请还车详情
var frameAuditDetail = res => require(['@/components/operat/frameAuditDetail.vue'], res) //车架号审核详情
var drivingLicenseFrameDetail = res => require(['@/components/operat/drivingLicenseFrameDetail.vue'], res) //行驶证审核详情
var helmetLockFailure = res => require(['@/components/operat/helmetLockFailure.vue'], res) // 头盔锁故障记录
var cameraFault = res => require(['@/components/operat/cameraFault.vue'], res) // 头盔锁故障记录
var newDispatchList = res => require(['@/components/operat/newDispatchList.vue'], res) //调度记录(新)
var dispatchNewDetail = res => require(['@/components/operat/dispatchNewDetail.vue'], res) //调度记录(新)详情
var beatStreetsList = res => require(['@/components/operat/beatStreetsList.vue'], res) //巡街记录
var beatStreetsDetail = res => require(['@/components/operat/beatStreetsDetail.vue'], res) //巡街记录详情
// 财务管理
var financialmains = res => require(['@/components/inance/financialmains.vue'], res) //退押金申请
var agentdayform = res => require(['@/components/inance/agentdayform.vue'], res) // 站点日结算报表
var orderSettlementList = res => require(['@/components/inance/orderSettlementList.vue'], res) // 骑行订单结算分析
var lnoviceSystem = res => require(['@/components/inance/lnoviceSystem.vue'], res) // 发票管理

// 用户上报
var pointApplyRecord = res => require(['@/components/useReport/pointApplyRecord.vue'], res) // P点申请记录
var pointApplyDetail = res => require(['@/components/useReport/pointApplyDetail.vue'], res) // P点申请记录详情
var violatList = res => require(['@/components/useReport/violatList.vue'], res) // 违规记录
var faultList = res => require(['@/components/useReport/faultList.vue'], res) // 违规记录
var bindDetail = res => require(['@/components/useReport/bindDetail.vue'], res) // 车辆详情用户上报记录（故障、违规记录）

// 设置
var menuManagement = res => require(['@/components/setup/menuManagement.vue'], res) //菜单权限管理
var reportSettingsMenu = res => require(['@/components/setup/reportSettingsMenu.vue'], res) //报表设置菜单
var costConfig = res => require(['@/components/setup/costconfig.vue'], res) //费用配置
var serviceConfig = res => require(['@/components/setup/serviceConfig.vue'], res) //地图配置配置
var userconf = res => require(['@/components/setup/userconf.vue'], res) //用户配置
var authority = res => require(['@/components/setup/authority.vue'], res) //角色权限
var account = res => require(['@/components/setup/account.vue'], res) //平台账号
var valuationRules = res => require(['@/components/setup/valuationRules.vue'], res) //平台账号
var customerConfig = res => require(['@/components/setup/customerConfig.vue'], res) // 客服工单配置
var operationRoleConfig = res => require(['@/components/setup/operationRoleConfig.vue'], res) // 运维角色配置
var operationReportConfig = res => require(['@/components/setup/operationReportConfig.vue'], res) // 运维报表配置
var siteConfiguration = res => require(['@/components/setup/siteConfiguration.vue'], res) // 站点后台权限配置
var delayTheTool = res => require(['@/components/setup/delayTheTool.vue'], res) // 骑行卡/券延期工具
var loginLog = res => require(['@/components/setup/loginLog.vue'], res) // 登录日志
var voltageFileConfig = res => require(['@/components/setup/voltageFileConfig.vue'], res) // 电压换算文件配置

const router = new Router({
  linkActiveClass: 'active',
  Router,
  // })

  // 懒加载方式，当路由被访问的时候才加载对应组件
  // Vue.use(Router)
  // export default new Router({
  routes: [{
    path: '/',
    redirect: {
      name: '登录'
    }
  }, {
    path: '/login',
    name: '登录',
    component: login
  },
  {
    path: '/menu',
    // name: '菜单栏',
    component: menu,
    children: [{
      path: '/',
      component: main
    },
    {
      path: '/notFound',
      name: '404',
      component: notFound
    }, {
      path: '/main',
      name: '工作台',
      component: main
    }, {
      path: '/helloPage',
      name: '欢迎页',
      component: helloPage
    },

    // 运营管理
    {
      path: '/dataScreen',
      name: 'dataScreen',
      component: dataScreen,
      // meta:{keepAlive:true}
    },
    {
      path: '/heatMap',
      name: 'P点统计',
      component: heatMap
    },
    {
      path: '/NewHeatMap',
      name: '新P点统计',
      component: NewHeatMap
    },
    {
      path: '/scaleHeatMap',
      name: '分级P点统计',
      component: scaleHeatMap
    },
    {
      path: '/linkTrack',
      name: '链路追踪',
      component: linkTrack
    },
    {
      path: '/operationalPosition',
      name: '运维位置',
      component: operationalPosition
    },
    {
      path: '/searchTrackDetail',
      name: '运维轨迹',
      component: searchTrackDetail
    },
    {
      path: '/dataScreenNew',
      name: 'dataScreenNew',
      component: dataScreenNew
    },
    {
      path: '/voltageChange',
      name: '电压变化',
      component: voltageChange
    },
    {
      path: '/VehicleOperationLog',
      name: '车辆操作日志',
      component: VehicleOperationLog
    },
    {
      path: '/bikeSearch',
      name: '车辆查询',
      component: bikeSearch
    },
    // 总资产管理
    {
      path: '/totalControl',
      name: '总中控管理',
      component: totalControl
    },
    {
      path: '/controlSwitchRecord',
      name: '中控协议记录',
      component: controlSwitchRecord
    },
    {
      path: '/switchRecordDetail',
      name: '中控协议记录发送日志详情',
      component: switchRecordDetail
    },
    // 资产管理
    {
      path: '/carsMana',
      name: '车辆管理',
      component: carsMana
    }, {
      path: '/carDetails',
      name: 'carDetails',
      component: carDetails,
    }, {
      path: '/controlMana',
      name: '中控管理',
      component: controlMana
    },
    {
      path: '/controlManaEdition',
      name: '中控版本管理',
      component: controlManaEdition
    },
    {
      path: '/controlDetails',
      name: '中控详情',
      component: controlDetails
    },
    {
      path: '/controlRecord',
      name: '中控记录',
      component: controlRecord
    },
    {
      path: '/controlLog',
      name: '中控日志',
      component: controlLog
    }, {
      path: '/iIssueList',
      name: '指令下发日志列表',
      component: iIssueList
    }, {
      path: '/iIssueDetail',
      name: '指令下发日志详情',
      component: iIssueDetail
    }, {
      path: '/batchlist',
      name: '批次列表',
      component: batchlist
    }, {
      path: '/batchDetail',
      name: '批次列表详情',
      component: batchDetail
    }, {
      path: '/accessories',
      name: '配件管理',
      component: accessories
    }, {
      path: '/storagelist',
      name: '入库记录',
      component: storagelist
    }, {
      path: '/entryRecordDetails',
      name: '入库记录详情',
      component: entryRecordDetails
    }, {
      path: '/accessoriesApplyRecord',
      name: '配件申请记录',
      component: accessoriesApplyRecord
    }, {
      path: '/accessoriesApplyDetails',
      name: '配件申请详情',
      component: accessoriesApplyDetails
    }, {
      path: '/receivingRecordList',
      name: '收货记录列表',
      component: receivingRecordList
    }, {
      path: '/siteInventory',
      name: '站点库存',
      component: siteInventory
    }, {
      path: '/accessoryUseDetail',
      name: '配件使用明细记录',
      component: accessoryUseDetail,
    }, {
      path: '/accessoryConsumeDetail',
      name: '配件消耗明细记录',
      component: accessoryConsumeDetail,
    }, {
      path: '/pzIntoDetail',
      name: '平账入库记录详情',
      component: pzIntoDetail,
    }, {
      path: '/pzOutDetail',
      name: '平账出库记录详情',
      component: pzOutDetail,
    }, {
      path: '/transferBatch',
      name: '调拨批次列表',
      component: transferBatch
    }, {
      path: '/allocationDetails',
      name: '调拨详情',
      component: allocationDetails
    }, {
      path: '/batchCarSearchTask',
      name: '批量寻车任务',
      component: batchCarSearchTask
    }, {
      path: '/searchCarDetail',
      name: '批量寻车任务详情',
      component: searchCarDetail
    }, {
      path: '/batchCarList',
      name: '批次车辆列表',
      component: batchCarList
    }, {
      path: '/bateryAccessories',
      name: '电池配件库',
      component: bateryAccessories
    }, {
      path: '/batteryClaimRecord',
      name: '电池申领记录',
      component: batteryClaimRecord
    }, {
      path: '/bateryApplyDetail',
      name: '电池申领记录详情',
      component: bateryApplyDetail
    }, {
      path: '/batteryReceivingRecord',
      name: '电池申领收货记录',
      component: batteryReceivingRecord
    }, {
      path: '/batteryInventory',
      name: '站点电池库存',
      component: batteryInventory
    }, {
      path: '/batteryScrapList',
      name: '电池报废列表',
      component: batteryScrapList
    }, {
      path: '/allocationCarDetail',
      name: '调拨列表',
      component: allocationCarDetail
    },



    // 人员管理
    {
      path: '/superUserDetail',
      name: '超级用户卡密详情',
      component: superUserDetail
    },
    {
      path: '/superUser',
      name: '超级用户卡密管理',
      component: superUser
    },
    {
      path: '/userList',
      name: '用户管理',
      component: userList
    }, {
      path: '/userdetail',
      component: userdetail,
      meta: {
        keepAlive: true
      }
    }, {
      path: '/realnameQuery',
      name: '实名信息查询',
      component: realnameQuery,
    }, {
      path: '/proxylist',
      name: '代理管理',
      component: proxylist
    },
    // 统计报表
    {
      path: '/daylist',
      component: daylist
    }, {
      path: '/monthlist',
      component: monthlist
    }, {
      path: '/totallist',
      component: totallist
    }, {
      path: '/ridelist',
      component: ridelist
    }, {
      path: '/userdatalist',
      component: userdatalist
    }, {
      path: '/paylist',
      component: paylist
    }, {
      path: '/bikelist',
      component: bikelist
    }, {
      path: '/orderErrorAnalyze',
      name: '订单创建失败分析',
      component: orderErrorAnalyze
    }, {
      path: '/customerCensus',
      name: '客服工单统计',
      component: customerCensus
    }, {
      path: '/siteCensus',
      name: '客服工单统计',
      component: siteCensus
    }, {
      path: '/noPassDetail',
      name: '工单审核不通过明细',
      component: noPassDetail
    }, {
      path: '/controlDataAnalyze',
      name: '中控数据分析',
      component: controlDataAnalyze
    }, {
      path: '/ChargingReport',
      name: '换电工作报表',
      component: ChargingReport
    }, {
      path: '/bikeAbnormal',
      name: '车辆异常报表',
      component: bikeAbnormal
    }, {
      path: '/noBoundControlBikeList',
      name: '未绑定中控车辆报表',
      component: noBoundControlBikeList
    }, {
      path: '/partsMonthlyApplicationReport',
      name: '配件月度申请报表',
      component: partsMonthlyApplicationReport
    }, {
      path: '/maintainWorkList',
      name: '维修工单统计',
      component: maintainWorkList
    }, {
      path: '/powerChangeSummary',
      name: '换电工作汇总',
      component: powerChangeSummary
    }, {
      path: '/accessoriesUseReport',
      name: '配件消耗明细报表',
      component: accessoriesUseReport
    }, {
      path: '/vehicleAssetsReport',
      name: '车辆资产报表',
      component: vehicleAssetsReport
    }, {
      path: '/cyclingCardSalesReport',
      name: '骑行卡销售报表',
      component: cyclingCardSalesReport
    },
    // 客服工单
    {
      path: '/servicepool',
      name: '运维工单池',
      component: servicepool
    }, {
      path: '/rodeOrderPool',
      name: '骑行退款工单池',
      component: rodeOrderPool
    }, {
      path: '/pending',
      name: '我待处理的',
      component: pending
    }, {
      path: '/processed',
      name: '我已处理的',
      component: processed
    }, {
      path: '/carsAudit',
      name: '车辆信息审核',
      component: carsAudit
    },
    {
      path: '/carsAudit',
      name: '车辆信息审核',
      component: carsAudit
    },
    {
      path: '/userReturnCar',
      name: '用户申请还车',
      component: userReturnCar
    },
    {
      path: '/userReturnCarDetail',
      name: '用户申请还车',
      component: userReturnCarDetail
    },
    {
      path: '/appealWorkPool',
      name: '申诉工单池',
      component: appealWorkPool
    },
    // 订单管理
    {
      path: '/rideorder',
      component: rideorder
    }, {
      path: '/orderdetail',
      component: orderdetail
    }, {
      path: '/rechargeorder',
      component: rechargeorder
    }, {
      path: '/ridecard',
      name: '骑行卡订单',
      component: ridecard
    }, {
      path: '/refundlist',
      name: '余额退款订单',
      component: refundlist
    }, {
      path: '/CyclingPackagePurchaseRecord',
      name: '骑行卡购买记录',
      component: CyclingPackagePurchaseRecord
    }, {
      path: '/orderRefundGoDetails',
      name: '订单退款记录详情',
      component: orderRefundGoDetails
    },

    // 营销管理
    {
      path: '/ridecoupon',
      name: '骑行券',
      component: ridecoupon
    },
    {
      path: '/operatePublic',
      name: '运营公告',
      component: operatePublic
    },
    {
      path: '/taskConfig',
      name: '任务配置',
      component: taskConfig
    },
    {
      path: '/activeConfig',
      name: '活动配置',
      component: activeConfig
    },
    {
      path: '/activity',
      name: '活动配置',
      component: activity
    },
    {
      path: '/carCardDiscountSetting',
      name: '骑行卡折扣配置',
      component: carCardDiscountSetting
    },
    {
      path: '/userLabelConfiguration',
      name: '用户标签配置',
      component: userLabelConfiguration
    },
    {
      path: '/ridePackageSetiing',
      name: '骑行卡配置',
      component: ridePackageSetiing
    },
    {
      path: '/batchTasksLog',
      name: '批量下发骑行日志',
      component: batchTasksLog
    },
    {
      path: '/camiloSetting',
      name: '骑行卡密管理',
      component: camiloSetting
    },
    {
      path: '/camiloDetail',
      name: '骑行卡密管理',
      component: camiloDetail
    },
    // 运维管理
    {
      path: '/dispatch',
      name: '调度记录',
      component: dispatch
    }, {
      path: '/dispatchDetail',
      name: '调度详情',
      component: dispatchDetail
    },
    {
      path: '/batchDispatchDetail',
      name: '批量调度详情',
      component: batchDispatchDetail
    }, {
      path: '/offlinelist',
      name: '离线记录',
      component: offlinelist
    }, {
      path: '/leaveDetail',
      name: '离线详情',
      component: leaveDetail
    }, {
      path: '/replacebatte',
      name: '换电记录',
      component: replacebatte
    }, {
      path: '/batteDetail',
      name: '换电详情',
      component: batteDetail
    }, {
      path: '/repairlist',
      name: '维修记录',
      component: repairlist
    }, {
      path: '/repairDetail',
      name: '维修详情',
      component: repairDetail
    }, {
      path: '/violatDetail',
      name: '违规详情',
      component: violatDetail
    }, {
      path: '/controlLeaveList',
      name: '中控下线记录',
      component: controlLeaveList
    }, {
      path: '/orderRefundDetails',
      name: '骑行订单退款详情',
      component: orderRefundDetails
    }, {
      path: '/carsAuditDetail',
      name: '车辆信息审核详情',
      component: carsAuditDetail
    }, {
      path: '/carInformationEntry',
      name: '车辆信息录入记录',
      component: carInformationEntry
    }, {
      path: '/carInformationDetail',
      name: '车辆信息录入记录详情',
      component: carInformationDetail
    }, {
      path: '/frameAuditDetail',
      name: '车架号审核详情',
      component: frameAuditDetail
    }, {
      path: '/drivingLicenseFrameDetail',
      name: '行驶证审核详情',
      component: drivingLicenseFrameDetail
    }, {
      path: '/helmetLockFailure',
      name: '头盔锁故障记录',
      component: helmetLockFailure
    }, {
      path: '/cameraFault',
      name: '摄像头故障记录',
      component: cameraFault
    }, {
      path: '/newDispatchList',
      name: '调度记录（新）',
      component: newDispatchList
    }, {
      path: '/dispatchNewDetail',
      name: '调度记录（新）详情',
      component: dispatchNewDetail
    }, {
      path: '/beatStreetsList',
      name: '巡街记录',
      component: beatStreetsList
    }, {
      path: '/beatStreetsDetail',
      name: '巡街记录详情',
      component: beatStreetsDetail
    },
    // 财务管理
    {
      path: '/financialmains',
      name: '财务统计',
      component: financialmains
    }, {
      path: '/agentdayform',
      name: '站点日结算报表',
      component: agentdayform
    },
    {
      path: '/orderSettlementList',
      name: '订单结算列表',
      component: orderSettlementList
    },
    {
      path: '/ridesettlementlist',
      name: '订骑行费用结算分析',
      component: ridesettlementlist
    }, {
      path: '/workOrderFaultAnalysis',
      name: '工单故障分析报表',
      component: workOrderFaultAnalysis
    }, {
      path: '/lnoviceSystem',
      name: '发票管理',
      component: lnoviceSystem
    },
    
    // 用户上报
    {
      path: '/pointApplyRecord',
      name: 'P点申请记录',
      component: pointApplyRecord
    },
    {
      path: '/pointApplyDetail',
      name: 'P点申请记录详情',
      component: pointApplyDetail
    },
    {
      path: '/violatList',
      name: '违规记录',
      component: violatList
    },
    {
      path: '/faultList',
      name: '故障记录',
      component: faultList
    },
    {
      path: '/bindDetail',
      name: '车辆详情用户上报记录（故障记录、违规记录）',
      component: bindDetail
    },
    // 设置
    {
      path: '/menuManagement',
      name: '菜单权限管理',
      component: menuManagement
    }, {
      path: '/reportSettingsMenu',
      name: '报表设置菜单',
      component: reportSettingsMenu
    }, {
      path: '/costConfig',
      name: '费用设置',
      component: costConfig
    }, {
      path: '/serviceConfig',
      name: '服务区设置',
      component: serviceConfig
    }, {
      path: '/userconf',
      name: '用户配置',
      component: userconf
    }, {
      path: '/authority',
      name: '权限设置',
      component: authority
    }, {
      path: '/account',
      name: '平台账号',
      component: account
    }, {
      path: '/valuationRules',
      name: '站点计价规则配置',
      component: valuationRules
    }, {
      path: '/customerConfig',
      name: '客服工单配置',
      component: customerConfig
    }, {
      path: '/operationRoleConfig',
      name: '运维角色配置',
      component: operationRoleConfig
    }, {
      path: '/operationReportConfig',
      name: '运维报表配置',
      component: operationReportConfig
    }, {
      path: '/siteConfiguration',
      name: '站点后台权限配置',
      component: siteConfiguration
    }, {
      path: '/delayTheTool',
      name: '骑行卡/券延期工具',
      component: delayTheTool
    }, {
      path: '/loginLog',
      name: '登录日志',
      component: loginLog
    }, {
      path: '/voltageFileConfig',
      name: '电压换算文件配置',
      component: voltageFileConfig
    },
    ]
  }]
})


Vue.use(Router)
router.beforeEach((to, from, next) => {

  const nextRoute = ['main', 'searchbike', 'carsMana', 'controlMana', 'rideorder', 'orderdetail', 'dispatch', 'dispatchDetail', 'offlinelist', 'leaveDetail', 'replacebatte', 'batteDetail', 'repairlist', 'repairDetail'];
  let isLogin = localStorage.getItem("total_token")

  if (nextRoute.indexOf(to.path) >= 0) {
    if (!isLogin) {
      router.push({ path: "/login" })
    }
  }
  if (to.path === '/login') {
    if (isLogin) {
      router.push({ path: '/main' });
    }
  };
  next();
});

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js